<template>
  <div>
    <abstractTable
      :columns="reservationsColumns"
      :data="formattedReservations"
      :classes="'ui very compact center aligned celled table'"
      :dataPerPage="15"
      :paginationEnable="true"
      :paginationNextButtonText="$t('next')"
      :paginationPervButtonText="$t('previous')"
      :paginationFirstPageButtonText="$t('first')"
      :paginationLastPageButtonText="$t('last')"
      v-if="reservations.length"
    />
    <div v-else>
      <div class="ui placeholder segment" style="margin-bottom: 50px">
        <div class="ui icon header" style="color: #092442">
          <i class="dont icon"></i>
          No Reservations have been made yet
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default
  },
  props: {
    reservations: { type: Array, required: true }
  },
  computed: {
    reservationsColumns () {
      return [
        { header: 'Id', fieldName: 'id', show: true, html: true },
        { header: 'Doctor', fieldName: 'doctor', show: this.getVisitRequiredSource() === 'doctor' },
        { header: 'Packages number', fieldName: 'packages_number', show: true },
        { header: 'Visits number', fieldName: 'visits_number', show: true }
      ]
    },
    formattedReservations () {
      const formattedReservations = []

      this.reservations.filter(r => !r.cancelled_at).forEach(reservation => {
        formattedReservations.push({
          id: {
            functionality: () => {
              this.navigateTo(`Show_Reservation`, { key: 'params', value: { id: reservation.id } })
            },
            value: `<a style="cursor: pointer;text-decoration:underline;">${reservation.id}</a>`
          },
          doctor: reservation.doctor ? reservation.doctor.user.name : '-',
          packages_number: reservation.reservations_packages.length,
          visits_number: reservation.reservation_visits.length
        })
      })

      return formattedReservations
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/patients/patient_log_componenets/applications_components/Reservations.vue